import type { JSX } from 'react'

import { QueryProgress } from '../design-system/query-progress.tsx'
import { useQueryActivity } from '../hooks/use-query-activity.ts'
import type { QueryActivityClock } from '../lib/query-activity.ts'

/**
 * QueryActivity — wires the app's react-query cache to the one indicator.
 *
 * Mounted once, inside the query provider, in `App.tsx`. A page never mounts
 * it and never reports a request: every query counts by itself, and one that
 * does not read the datalake opts out with `QUIET_QUERY_META`.
 *
 * @param props - QueryActivity props.
 * @param props.clock - The time source. Tests pass a clock they move by hand.
 * @returns The indicator.
 */
export function QueryActivity({
  clock
}: {
  clock?: QueryActivityClock
}): JSX.Element | null {
  return (
    <QueryProgress
      data-testid="query-progress"
      activity={useQueryActivity(clock)}
    />
  )
}
